import React from 'react';
import { fetchBlobUrl } from '../utils/authedResource';

const isPassthroughSrc = (src) => {
  const s = String(src || '').trim();
  if (!s) return true;
  // data/blob 可以直接展示；presigned URL 不要直连（可能证书/CORS/权限问题），交给 fetchBlobUrl 走后端代理。
  return s.startsWith('data:') || s.startsWith('blob:');
};

export default function AuthedImage({ src, alt, style, className, ...rest }) {
  const [resolved, setResolved] = React.useState(() => (isPassthroughSrc(src) ? src : ''));

  React.useEffect(() => {
    let alive = true;
    let objectUrl = '';

    const run = async () => {
      const s = String(src || '').trim();
      if (!s) {
        if (alive) setResolved('');
        return;
      }
      if (isPassthroughSrc(s)) {
        if (alive) setResolved(s);
        return;
      }
      try {
        objectUrl = await fetchBlobUrl(s);
        if (alive) setResolved(objectUrl);
      } catch (e) {
        if (alive) setResolved('');
      }
    };

    run();

    return () => {
      alive = false;
      if (objectUrl) {
        try { URL.revokeObjectURL(objectUrl); } catch (e) {}
      }
    };
  }, [src]);

  if (!resolved) return null;
  return <img src={resolved} alt={alt || ''} style={style} className={className} {...rest} />;
}
